import * as types from "./types";

import { colors } from "../../../data/Colors";
export const tool = {
  namespaced: true,

  state: {
    colorPalette: colors,
    paletteOpen: false,
    tool: 1,
    // colorは共通
    size: 1,
    color: 6,
    spray: {
      alpha: [0.5, 0.35, 0.25]
    },
    text: {
      size: 1,
      x: 0,
      y: 0,
      rotation: 0,
      scale: 1,
      state: types.TEXT_STATE_COLOR, // color or text or
      transState: types.TEXT_TRANS_MOVE,
      texts: [],
      isTransforming: false
    }
  },
  getters: {
    texts: (state) =>{
      return state.text.texts.join()
    }
  },
  mutations: {
    setPaletteOpen(state, isOpen) {
      state.paletteOpen = isOpen;
    },
    resetTextTool(state) {
      state.text.scale = 1;
      state.text.x = 0;
      state.text.y = 210 / 2; // TODO Canvasの高さを持ってきたい。ちがうパラメータにして保持しておく？
      state.text.rotation = 0;
      state.transState = types.TEXT_TRANS_MOVE;
    },
    setTool(state, tool) {
      state.tool = tool;
      if (tool == 3)
        this.dispatch(types.namespace + types.SET_TEXT_STATE, types.TEXT_STATE_INPUT);
    },
    setColor(state, color) {
      state.color = color;
    },
    setSize(state, size) {
      state.size = size;
    },
    setTextState(state, textState) {
      state.text.state = textState;
    },
    setTextTrans(state, textTrans) {
      state.text.transState = textTrans;
    },
    addText(state, text) {
      state.text.texts.push(text);
    },
    cancelText(state) {
      const texts = state.text.texts;
      if (texts.length == 0)
        return;
      // if (texts[texts.length - 1] == text)
        texts.pop()
    },
    restoreTexts(state, texts) {
      state.text.texts = texts;
    },
    resetText(state) {
      state.text.texts = [];
    }
  },
  actions: {
    [types.SET_PALETTE_OPEN]({ commit }, isOpen) {
      commit("setPaletteOpen", isOpen);
    },
    [types.RESET_TEXT_TOOL]({ commit }) {
      commit("resetTextTool");
    },
    [types.SET_TOOL]({ commit }, tool) {
      commit("setTool", tool);
    },
    [types.SET_COLOR]({ commit }, color) {
      commit("setColor", color);
    },
    [types.SET_SIZE]({ commit }, size) {
      commit("setSize", size);
    },
    [types.SET_TEXT_STATE]({ commit }, textState) {
      commit("setTextState", textState);
    },
    [types.SET_TEXT_TRANS]({ commit }, transState) {
      commit("setTextTrans", transState);
    },
    [types.ADD_TEXT]({ commit }, text) {
      commit("addText", text);
    },
    [types.CANCEL_TEXT]({ commit }) {
      commit("cancelText");
    },
    [types.RESTORE_TEXTS]({ commit }, texts) {
      commit("restoreTexts", texts);
    },
    [types.RESET_TEXT]({ commit }) {
      commit("resetText");
    }
  }
};
